import axios from "axios";
import index from "../api";
import router from "../../router";
import i18n from "@/i18n";

class AuthService {
  async login(user) {
    try {
      const response = await axios.post(
        process.env.VUE_APP_BASE_URL + "/authenticate",
        {
          email: user.email,
          password: user.password,
          captchaToken: user.captchaToken,
        }
      );
      if (response.data) {
        if (response.data.user.imagePath === null) {
          response.data.user.imagePath = require("@/assets/images/dawan_logo.png");
        }
        $cookies.set("auth", JSON.stringify(response.data));
      }
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      }
    }
  }

  testDg2LogIn(user) {
    return axios.post(
      process.env.VUE_APP_BASE_URL + "/test-dg2-login",
      {
        email: user.email,
        password: user.password,
      },
      {
        headers: {
          Authorization: this.getBearerToken(),
        },
      }
    );
  }

  async logout() {
    $cookies.remove("auth");
    await index.dispatch("websocketModule/logoutFromWebsocket");
    router.push(`/${i18n.locale}`);
  }

  getExpirationDate() {
    let auth = this.getAuth();

    if (auth) return auth.token.expirationDate;
    else return null;
  }

  getAuth() {
    return $cookies.get("auth");
  }

  setAuth(auth) {
    $cookies.set("auth", auth);
  }

  getBearerToken() {
    let auth = this.getAuth();

    if (auth) return "Bearer " + auth.token.value;
    else return null;
  }

  getUser() {
    let auth = this.getAuth();

    if (auth) return auth.user;
    else return null;
  }

  setUser(user) {
    let auth = this.getAuth();
    if (auth.user) auth.user = user;
    this.setAuth(auth);
  }

  isAuth() {
    return $cookies.get("auth");
  }

  userHasSomeRoles(roles) {
    return this.getAuth().user.types.some((x) => roles.includes(x));
  }

  userHasEveryRoles(roles) {
    return this.getAuth().user.types.every((x) => roles.includes(x));
  }
}

export default new AuthService();
